import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import { findByIdWithStatsFor, findCampaignById, getInventoryItemsAsString, payoutCampaign } from 'components/graphql/queries'
import Layout from 'components/misc/Layout';
import { closeModal, openModal } from 'components/modal/modules/dispatcher/methods';

import { stripUriParamsString } from 'lib/utils/helpers';
import React, { useCallback, useEffect, useState } from 'react'
import Moment from 'react-moment'
import { connect } from 'react-redux';
import UserDucks from 'stores/ducks/User.duck';

import { geocodeByPlaceId } from 'react-google-places-autocomplete';

import { Card, CardBody, CardImg, Col, Row } from 'reactstrap';

import {
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from 'reactstrap';

import { deleteCampaign, isUserHost } from 'components/graphql/queries'

import CampaignSettings from './CampaignSettings';
import Description from './Description';
import InventoryTable from './InventoryTable';
import Leaderboard from './Leaderboard';
import OrdersTable from './OrdersTable';

import EmailsModal from './Emails';

import Checkin from '../Checkin/Validate';

import { Tab, TabList, TabPanel, Tabs, } from 'react-tabs';

import 'react-tabs/style/react-tabs.css';

import MapComponent from '../../../components/map'
// import { CardOutline, TrashOutline } from 'react-ionicons'


const CampaignDashboard: React.FC<{ [label: string]: any }> = (props: any) => {

    if (props.user.id === '') {
        return null;
    }

    const [campaignId] = useState(stripUriParamsString(props.match.params.campaignId))
    const [loading, setLoading] = useState(true)
    const [users, setUsers] = useState<any[]>([])
    const [isHost, setIsHost] = useState(false)
    const [selectedUserName, setSelectedUserName] = useState(props.user.username)
    const [marker, setMarker] = useState<any>(null)

    const [campaign, setCampaign] = useState<any>({
        name: '',
        revenue: 0,
        directSales: 0,
        checkedIn: 0,
        indirectSales: 0,
        linkPageViews: 0,
        disputeAmount: 0,
        totalEarnings: 0,
        payoutDate: null,
        earlyPayout: false,
        description: '',
        isActive: true,
        createdBy: '',
        createdByUsername: '',
        hideDisplayTime: false,
        subdomain: '',
        endTime: {
            year: 0,
            month: 0,
            day: 0,
            hour: 0,
            minute: 0,
            PM: false,
        },
        startTime: {
            year: 0,
            month: 0,
            day: 0,
            hour: 0,
            minute: 0,
            PM: false,
        },
        media: {
            cover: '',
            logo: ''
        },
        deletedAt: null,
        totalPlatformFee: 0,
        totalStripeFee: 0,
        floorplan: {},
        showLeaderboard: false,
        maxLevels: null,
        location: null,
        secretLocation: null
    })
    const [key, setKey] = useState(0)

    useEffect(() => {
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: isUserHost,
                variables: {
                    userId: props.user.id,
                    campaignId
                }
            })
            .then(res => {
                if (res.data && res.data.data.cohost.isHost) {
                    console.log(res)
                    setIsHost(true)
                }
            })
            .catch(err => {
                console.log(err)
            })
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: findCampaignById,
                variables: {
                    id: campaignId
                }
            })
            .then(res => {
                setCampaign(res.data.data.campaign.findById)
                if (props.user.isAdmin && loading) {
                    setSelectedUserName(res.data.data.campaign.findById.createdByUsername)
                }
            })
            .catch(err => {
                console.log(err)
            })
    }, [setLoading, campaignId, setCampaign, props.user, loading])

    useEffect(() => {
        loadAffiliates()
        if (campaign.location !== undefined && campaign.location !== null) {
            const loc = JSON.parse(campaign.location)
            console.log(loc)
            geocodeByPlaceId(loc.value.place_id)
                .then(results => {
                    const mark = {
                        lat: results[0].geometry.location.lat(),
                        lng: results[0].geometry.location.lng()
                    }
                    setMarker(mark)
                })
                .catch(error => console.error(error));
        }
    }, [campaign, key])

    const loadAffiliates = useCallback(() => {
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: getInventoryItemsAsString,
                variables: {
                    campaignId,
                    sellerId: props.user.isAdmin ? campaign.createdBy : props.user.id
                }
            })
            .then(res => {
                const int = JSON.parse(res.data.data.inventoryItem.getInventoryAsString)
                const u: string[] = []
                int.map((item: any) => {
                    item.sharedBy.map((i: any) => {
                        if (u.find((o) => {
                            return i.username === o
                        }) === undefined && !i.username.includes("-additional-link-")) {
                            u.push(i.username)
                        }
                    })
                })
                setUsers(u)
            })
    }, [props.user, campaignId, campaign])

    useEffect(() => {
        reloadData()
    }, [selectedUserName])

    const reloadData = useCallback((u?: any) => {
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: findByIdWithStatsFor,
                variables: {
                    id: campaignId,
                    username: u ? u : selectedUserName
                }
            })
            .then(res => {
                setCampaign(res.data.data.campaign.findByIdWithStatsFor)
                setKey(Math.random())
                setLoading(false)
            })
            .catch(err => {
                console.log(err)
            })
    }, [setLoading, campaignId, setCampaign, props.user, selectedUserName])

    const openCampaignSettingsModal = useCallback(() => {
        const content = <CampaignSettings
            {...campaign}
            reloadData={() => reloadData()}
            campaignId={campaignId}
        />
        openModal(content, "EDIT EVENT", [])
    }, [campaign, reloadData, campaignId, key])

    const handleDelete = useCallback(() => {
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: deleteCampaign,
                variables: {
                    id: campaignId
                }
            })
            .then(res => {
                if (res.data.data.campaign.delete) {
                    window.location.pathname = '/campaigns'
                }
            })
            .catch(err => {
                console.log(err)
            })
    }, [campaignId])

    const payout = useCallback(() => {
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: payoutCampaign,
                variables: {
                    campaignId
                }
            })
            .then(res => {
                if (res.data.data.campaign.payout) {
                    reloadData()
                    const content = <div style={{ padding: '20px' }}>
                        Payout has been initiated. Funds will be available to the campaign's owner in 2-3 days.
                        <div style={{ width: '100%', textAlign: 'center', paddingTop: '20px' }}>
                            <button
                                className="new-button-save"
                                style={{ cursor: 'pointer' }}
                                onClick={() => closeModal()}
                            >
                                DONE
                            </button>
                        </div>
                    </div>
                    openModal(content, 'PAYOUT INITIATED', [])
                }
            })
            .catch(err => {
                console.log(err)
            })
    }, [campaignId, reloadData, closeModal, campaign])

    if (loading) {
        return null;
    }

    if (campaign && campaign.deletedAt) {
        return <div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
            <div className="w-100 text-center" style={{ paddingTop: '50px' }}>
                <div>
                    <h6 style={{ textAlign: 'center' }} className="sexyBlack">
                        <strong>
                            Deleted Campaign<br />
                            <small>Contact info@isotopeticketing.com for more info.</small><br /><br />
                        </strong>
                    </h6>
                </div>
            </div>
        </div>
    }

    const usersIncludingCurrentUser: any[] =
        props.user.isAdmin || campaign.createdBy.toString().trim() === props.user.id
            ? [campaign.createdByUsername]
            : [props.user.username]
    users.map((u: any) => {
        usersIncludingCurrentUser.push(u)
    })
    const affiliates = usersIncludingCurrentUser.map((item, ind) => {
        return <DropdownItem key={ind} onClick={() => {
            setSelectedUserName(item)
            reloadData(item)
        }}>
            {item}
        </DropdownItem>
    })

    const leftCol = <>
        <Card style={{ width: '100%' }}>
            <CardImg top={true}
                src={campaign.media.cover ? campaign.media.cover : "https://platform.isotopeticketing.com/landing.png"}
                alt="Campaign Image"
                style={{
                    borderTopLeftRadius: '15px',
                    borderTopRightRadius: '15px',
                    objectFit: 'contain'
                }}
            />
            <CardBody>
                <h4 className='cut-text' style={{ width: '100%' }}>
                    {campaign.name}
                </h4>
                <div style={{ flexDirection: 'row', display: 'flex', width: 375, maxWidth: '100%', marginBottom: 10 }}>
                    {
                        campaign.hideDisplayTime ? null :
                            <p className='gray-text' style={{ height: '28px', paddingTop: 10 }}>
                                <Moment format="D MMM 'YY, " style={{ paddingRight: '5px', paddingLeft: '2px' }}>
                                    {Number(new Date(
                                        campaign.startTime.year,
                                        campaign.startTime.month - 1,
                                        campaign.startTime.day,
                                        (campaign.startTime.PM ? campaign.startTime.hour + 12 : campaign.startTime.hour),
                                        campaign.startTime.minute
                                    ))}
                                </Moment>
                                <Moment format="hh:mm A">
                                    {Number(new Date(
                                        campaign.startTime.year,
                                        campaign.startTime.month - 1,
                                        campaign.startTime.day,
                                        (campaign.startTime.PM ? campaign.startTime.hour + 12 : campaign.startTime.hour),
                                        campaign.startTime.minute
                                    ))}
                                </Moment>
                            </p>
                    }
                    {
                        campaign.createdBy === props.user.id || props.user.isAdmin || isHost ?
                            <div className='new-button-white-4' style={{ paddingRight: '0px', cursor: campaign.payoutDate ? 'not-allowed' : 'pointer' }} onClick={() => {
                                if (!campaign.payoutDate) {
                                    openCampaignSettingsModal()
                                }
                            }}>
                                Edit
                            </div> : null
                    }
                    {
                        props.user.isAdmin ?
                            <div className='new-button-white-4' style={{ paddingRight: '0px' }} onClick={() => handleDelete()}>
                                Delete
                            </div> : null
                    }
                    {
                        props.user.isAdmin && !campaign.isActive && (
                            campaign.createdBy.toString().trim() !== ('5f2ccd72e1a6fa3933ca604e').toString().trim()
                            && campaign.createdBy.toString().trim() !== ('5f334e02a25bd23882873ba5').toString().trim()
                        ) && campaign.revenue !== 0 ?
                            (
                                campaign.payoutDate ?
                                    <button className='new-button-white-4 payout' style={{ paddingRight: '0px', cursor: 'not-allowed' }} disabled={true}>
                                        PAID OUT
                                    </button> :
                                    <button className='new-button-white-4' style={{ paddingRight: '0px' }} onClick={() => payout()}>
                                        PAY OUT
                                    </button>
                            ) : null
                    }
                </div>
                {
                    campaign.createdBy === props.user.id ?
                        <span className="notify-owner" style={{ fontSize: '12px' }}>OWNER</span> :
                        (props.user.isAdmin ? null :
                            <span className="notify-affiliate" style={{ fontSize: '12px' }}>AFFILIATE</span>)
                }
                <Description>
                    {campaign.description}
                </Description>
            </CardBody>
            {
                marker ?
                    <div>
                        <MapComponent
                            marker={marker}
                        />
                    </div>
                    : null
            }
        </Card>
        {/* {
            screen.width < 768 ?
                <div className='card' style={{ padding: '20px', marginBottom: '25px', marginTop: '25px', borderTopRightRadius: 0, borderTopLeftRadius: 0 }}>
                    <h6 style={{ display: 'flex', flexDirection: 'row', fontWeight: 'bold' }}>
                        <span>View sales for - </span>
                        <span>
                            <UncontrolledDropdown style={{ float: 'right', paddingLeft: '10px', marginTop: '-4px' }}>
                                <DropdownToggle
                                    className='new-button-white-4'
                                    data-toggle="dropdown"
                                    tag='button'
                                >
                                    {selectedUserName}  ▼
                                </DropdownToggle>
                                <DropdownMenu style={{ borderRadius: '10px' }}>
                                    <DropdownItem header={true}>Team Member</DropdownItem>
                                    {affiliates}
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </span>
                        {
                            campaign.isActive ? null :
                                <span style={{ width: 'auto', float: 'left' }}>
                                    <p>
                                        &nbsp;&nbsp;(Sales Ended)
                                    </p>
                                </span>
                        }
                        {
                            props.user.isAdmin ?
                                <span style={{ paddingLeft: 50 }}>
                                    IF: ${(campaign.totalPlatformFee / 100).toFixed(2)}     SF: ${(campaign.totalStripeFee / 100).toFixed(2)}
                                </span>
                                : null
                        }
                    </h6>

                    <Row style={{ paddingTop: '20px' }}>
                        <Col>
                            <Row>
                                <Col>
                                    <p>
                                        Total<br />Earnings
                                    </p>
                                    <h5>
                                        ${(campaign.totalEarnings / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                                    </h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <p>
                                        Total<br />Sales
                                    </p>
                                    <h5>
                                        {(campaign.directSales + campaign.indirectSales).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                                    </h5>
                                </Col>
                            </Row>
                            {
                                campaign.disputeAmount !== 0 ?
                                    <Row>
                                        <Col>
                                            <p>
                                                Amount<br />Disputed
                                            </p>
                                            <h5>
                                                ${(campaign.disputeAmount / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                                            </h5>
                                        </Col>
                                    </Row> : null
                            }
                        </Col>
                        <Col>
                            <Row>
                                <Col>
                                    <p>
                                        Your<br />Earnings
                                    </p>
                                    <h5>
                                        ${(campaign.revenue / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                                    </h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <p>
                                        Your<br />Sales
                                    </p>
                                    <h5>
                                        {campaign.directSales.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                                    </h5>
                                </Col>
                            </Row>
                        </Col>
                        <Col>
                            <Row>
                                <Col>
                                    <p>
                                        Affiliate<br />Earnings
                                    </p>
                                    <h5>
                                        ${((campaign.totalEarnings - campaign.revenue) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                                    </h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <p>
                                        Affiliate<br />Sales
                                    </p>
                                    <h5>
                                        {campaign.indirectSales.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                                    </h5>
                                </Col>
                            </Row>
                        </Col>
                        {
                            campaign.checkedIn !== 0 ?
                                <Col>
                                    <p>
                                        Tickets<br />Checked-In
                                    </p>
                                    <h5>
                                        {campaign.checkedIn.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                                    </h5>
                                </Col> : null
                        }
                    </Row>
                </div> : null
        } */}
    </>

    const rightCol = <>
        {/* {
            screen.width >= 768 ? */}
        <Tabs>
            {/* TABS LIST */}
            <TabList style={{ marginBottom: 0, paddingBottom: 0, border: 'none' }}>
                <Tab style={{ fontWeight: 'bold' }}>SALES</Tab>
                <Tab style={{ fontWeight: 'bold' }}>LINKS & TICKETS</Tab>
                <Tab style={{ fontWeight: 'bold' }}>TEAM</Tab>
                <Tab style={{ fontWeight: 'bold' }}>PROMOTE</Tab>
                <Tab style={{ fontWeight: 'bold' }}>CHECK-IN</Tab>
                <Tab style={{ fontWeight: 'bold' }}>ORDERS</Tab>
            </TabList>
            {/* TABS CONTENT */}
            {/* Sales Panel */}
            <TabPanel style={{ borderBottomLeftRadius: 15, borderBottomRightRadius: 15, marginTop: 0 }}>
                <div className='card' style={{ padding: '20px', marginBottom: '25px', borderTopLeftRadius: 0 }}>
                    <p style={{ display: 'flex', flexDirection: 'row' }}>
                        <span>View sales for - </span>
                        <span>
                            <UncontrolledDropdown style={{ float: 'right', paddingLeft: '10px', marginTop: '-4px' }}>
                                <DropdownToggle
                                    className='new-button-white-4'
                                    data-toggle="dropdown"
                                    tag='button'
                                >
                                    {selectedUserName}  ▼
                                </DropdownToggle>
                                <DropdownMenu style={{ borderRadius: '10px' }}>
                                    <DropdownItem header={true}>Team Member</DropdownItem>
                                    {affiliates}
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </span>
                        {
                            campaign.isActive ? null :
                                <span style={{ width: 'auto', float: 'left' }}>
                                    <p>
                                        &nbsp;&nbsp;(Sales Ended)
                                    </p>
                                </span>
                        }
                        {
                            props.user.isAdmin ?
                                <span style={{ paddingLeft: 50 }}>
                                    IF: ${(campaign.totalPlatformFee / 100).toFixed(2)}     SF: ${(campaign.totalStripeFee / 100).toFixed(2)}
                                </span>
                                : null
                        }
                    </p>

                    <Row style={{ paddingTop: '20px' }}>
                        <Col>
                            <Row>
                                <Col>
                                    <p>
                                        {
                                            selectedUserName === props.user.username || (props.user.isAdmin && selectedUserName === campaign.createdByUsername)
                                                ? 'Total Revenue' : 'Revenue'
                                        }
                                    </p>
                                    <h5>
                                        ${(campaign.totalEarnings / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                                    </h5>
                                </Col>
                            </Row>
                            <Row style={{ paddingTop: '15px' }}>
                                <Col>
                                    <p>
                                        {
                                            selectedUserName === props.user.username || (props.user.isAdmin && selectedUserName === campaign.createdByUsername)
                                                ? 'Total Sales' : 'Sales'
                                        }
                                    </p>
                                    <h5>
                                        {(campaign.directSales + campaign.indirectSales).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                                    </h5>
                                </Col>
                            </Row>
                            {
                                campaign.disputeAmount !== 0 ?
                                    <Row>
                                        <Col>
                                            <p>
                                                Amount Disputed
                                            </p>
                                            <h5>
                                                ${(campaign.disputeAmount / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                                            </h5>
                                        </Col>
                                    </Row> : null
                            }
                        </Col>
                        <Col>
                            <Row>
                                <Col>
                                    <p>
                                        {
                                            selectedUserName === props.user.username || (props.user.isAdmin && selectedUserName === campaign.createdByUsername)
                                                ? 'Your Revenue' : 'Affiliate Revenue'
                                        }
                                    </p>
                                    <h5>
                                        ${(campaign.revenue / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                                    </h5>
                                </Col>
                            </Row>
                            <Row style={{ paddingTop: '15px' }}>
                                <Col>
                                    <p>
                                        {
                                            selectedUserName === props.user.username || (props.user.isAdmin && selectedUserName === campaign.createdByUsername)
                                                ? 'Your Sales' : 'Affiliate Sales'
                                        }
                                    </p>
                                    <h5>
                                        {campaign.directSales.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                                    </h5>
                                </Col>
                            </Row>
                        </Col>
                        <Col>
                            <Row>
                                <Col>
                                    <p>
                                        {
                                            selectedUserName === props.user.username || (props.user.isAdmin && selectedUserName === campaign.createdByUsername)
                                                ? 'Affiliate Revenue' : 'Sub-Affiliate Revenue'
                                        }
                                    </p>
                                    <h5>
                                        ${((campaign.totalEarnings - campaign.revenue) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                                    </h5>
                                </Col>
                            </Row>
                            <Row style={{ paddingTop: '15px' }}>
                                <Col>
                                    <p>
                                        {
                                            selectedUserName === props.user.username || (props.user.isAdmin && selectedUserName === campaign.createdByUsername)
                                                ? 'Affiliate Sales' : 'Sub-Affiliate Sales'
                                        }
                                    </p>
                                    <h5>
                                        {campaign.indirectSales.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                                    </h5>
                                </Col>
                            </Row>
                        </Col>
                        {
                            campaign.checkedIn !== 0 ?
                                <Col>
                                    <p>
                                        Tickets Checked-In
                                    </p>
                                    <h5>
                                        {campaign.checkedIn.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                                    </h5>
                                </Col> : null
                        }
                    </Row>
                </div>
            </TabPanel>
            {/* Links and Tickets Panel */}
            <TabPanel>
                <InventoryTable
                    isHost={isHost}
                    campaignId={campaignId}
                    createdBy={campaign.createdBy}
                    isActive={campaign.isActive}
                    subdomain={campaign.subdomain}
                    createdByUsername={campaign.createdByUsername}
                    selectedUserName={selectedUserName}
                    setSelectedUserName={(u: any) => setSelectedUserName(u)}
                    startTime={campaign.startTime}
                    endTime={campaign.endTime}
                    maxLevels={campaign.maxLevels}
                    floorplan={campaign.floorplan}
                    fpBackground={campaign.media.logo}
                    reloadData={() => reloadData()}
                    key={key}
                />
            </TabPanel>
            {/* Team Panel */}
            <TabPanel>
                {
                    campaign.showLeaderboard ?
                        <Leaderboard
                            isHost={isHost}
                            users={users}
                            campaignId={campaignId}
                            createdBy={campaign.createdBy}
                        /> : null
                }
            </TabPanel>
            {/* Promote Panel */}
            <TabPanel>
                <div className='card' style={{ padding: '20px', marginBottom: '25px' }}>
                    <EmailsModal
                        canBroadcast={isHost || props.user.isAdmin || campaign.createdBy.toString().trim() === props.user.id.toString().trim()}
                        campaignId={campaignId}
                    />
                </div>
            </TabPanel>
            {/* Check-in Panel */}
            <TabPanel>
                <div className='card' style={{ padding: '20px', marginBottom: '25px' }}>
                    <Checkin
                        campaignId={campaignId}
                        reloadData={() => reloadData()}
                    />
                </div>
            </TabPanel>
            {/* Orders Panel */}
            <TabPanel>
                <OrdersTable
                    createdBy={campaign.createdBy}
                    campaignId={campaignId}
                    isActive={campaign.isActive}
                    reloadData={() => reloadData()}
                    users={users}
                    selectedUserName={selectedUserName}
                    createdByUsername={campaign.createdByUsername}
                    setSelectedUserName={(u: any) => setSelectedUserName(u)}
                />
            </TabPanel>
        </Tabs>
        {/* : null
        } */}

    </>

    return <div className='container'>
        <Layout
            leftCol={leftCol}
            rightCol={rightCol}
        />
    </div >
}

const mapStateToProps = state => ({
    user: UserDucks.getUser(state),
});

export default connect(mapStateToProps)(CampaignDashboard);


// WEBPACK FOOTER //
// ./src/pages/campaign/CampaignsDashboard/CampaignDashboard.tsx